import { date } from "colbi_web_ui/lib/utils";
import { adjustForTimezone } from "../../utils/convertUtils";
import { displayValue } from "./utils/mapperUtils";

const formatExpirationDate = (projectExpirationDate) => {
    if (!projectExpirationDate) {
        return "N/A";
    }
    return displayValue(date(adjustForTimezone(projectExpirationDate).getTime()));
};

export const mapCard = (json) => {
    const {
        taxRegistrationNumber,
        description,
        fiscalYears,
        active,
        projectExpirationDate,
        organization: { name: organizationName } = {},
    } = json;

    return [
        [
            {
                labels: ["tax_registration_number"],
                value: displayValue(taxRegistrationNumber),
                type: "string",
                basis: "10%",
            },
        ],
        [{ labels: ["name"], value: displayValue(description), type: "string", basis: "50%" }],
        [{ labels: ["organization"], value: displayValue(organizationName), type: "string" }],
        [
            {
                labels: ["fiscalYears"],
                value: (Object.keys(fiscalYears || {}) || []).join(", ") || "N/A",
                type: "string",
            },
        ],
        [
            {
                labels: ["expiration_date"],
                value: formatExpirationDate(projectExpirationDate),
                type: "string",
            },
        ],
        [
            {
                labels: ["active"],
                value: {
                    customComponent: "ActiveStatus",
                    active,
                },
                type: "customComponent",
                basis: "10%",
                align: "center",
            },
        ],
    ];
};

const mapper = (json, card, details) => {
    return {
        ...json,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
    };
};

const header = [
    { label: ["Tax ID"], align: "left", basis: "10%" },
    { label: ["ProjectName"], align: "left", basis: "50%" },
    { label: ["Organization"], align: "left" },
    { label: ["Fiscal Year"], align: "left" },
    { label: ["Expiration Date"], align: "left", columnName: "projectExpirationDate" },
    { label: ["Active"], align: "center", basis: "10%", type: "customComponent" },
];

const projectMapper = {
    map: mapper,
    header,
};

export default projectMapper;
